<div class="transfer-page">

  @if (pageLoading) {
    <app-loading-overlay [visible]="true" [indeterminate]="true"></app-loading-overlay>
  } @else {

  <!-- Back to Dashboard (Figma 596-5182 / mobile 649-2864) -->
  <div class="transfer-back-row">
    <app-back-button />
  </div>

  <!-- Page Header -->
  <div class="transfer-header" [class.transfer-header--hide-mobile]="currentStep !== 1">
    <div class="transfer-title-group">
      <h1 class="transfer-title">{{ 'fund.actions.transfer.title' | translateLang }}</h1>
      <p class="transfer-subtitle">{{ 'transfer.subtitle' | translateLang }}</p>
    </div>
    @if (funds().length > 0 && currentStep === 1) {
      <app-fund-switcher
        [funds]="funds()"
        [selectedFundId]="selectedFundId()"
        [variant]="'yellow'"
        [numberFormat]="numberFormatConfig"
        (fundChanged)="onFundChanged($event)"
      />
    }
  </div>

  <!-- Step Indicator -->
  <div class="stepper-container">
    <app-stepper [steps]="stepperSteps" [activeStepIndex]="activeStepIndex" />
  </div>

  <!-- Step 1: Form -->
  <div [hidden]="currentStep !== 1">
    <div class="form-content">
      <app-transfer-form
        [currentFund]="currentFund"
        [userFunds]="funds()"
        [displayCurrencySymbol]="selectedCurrency()?.symbol || null"
        [grantingCurrencyBalance]="selectedCurrency()?.availableAmountFundCash ?? null"
        (formChangedEvent)="transferFormData = $event"
        (formIsValid)="transferFormValid = $event"
      />
    </div>
    <div class="button-container">
      <p class="step-counter">{{ 'contribute.step_counter' | translateLang: { current: currentStep, total: stepperSteps.length } }}</p>
      <button
        type="button"
        class="lg-button form-next-button"
        [disabled]="!transferFormValid"
        (click)="goToSummary()"
      >
        {{ 'common.next' | translateLang }}
      </button>
    </div>
  </div>

  <!-- Step 2: Summary -->
  @if (currentStep === 2) {
    <div class="form-content">
      @if (showError) {
        <div class="alert-box">{{ 'transfer.error.server' | translateLang }}</div>
      }
      <app-transfer-summary
        [displayData]="transferDisplayData"
        [currency]="selectedCurrency()?.symbol || currentFund?.currencySymbol"
      />
    </div>
    <div class="button-container">
      <p class="step-counter">{{ 'contribute.step_counter' | translateLang: { current: currentStep, total: stepperSteps.length } }}</p>
      <div class="button-row">
        <button type="button" class="lg-button form-back-button" [disabled]="loading" (click)="goToForm()">
          {{ 'common.back' | translateLang }}
        </button>
        <button type="button" class="lg-button form-next-button" [disabled]="loading" (click)="onSubmit()">
          @if (loading) {
            <span class="button-spinner"></span>
          }
          {{ 'transfer.summary.next' | translateLang }}
        </button>
      </div>
    </div>
  }

  <!-- Step 3: Confirmation -->
  @if (currentStep === 3) {
    <div class="completion-card">
      <h2 class="completion-title">{{ 'transfer.completion.thank_you' | translateLang }}</h2>
      <p class="completion-subtitle">{{ 'transfer.completion.sent' | translateLang }}</p>
      <div class="completion-pending-box">
        <p
          class="completion-body"
          [innerHTML]="'transfer.completion.see_pending' | translateLang : { link: 'fund/activity/pending' }"
        ></p>
      </div>
    </div>
    <div class="button-container">
      <p class="step-counter">{{ 'contribute.step_counter' | translateLang: { current: currentStep, total: stepperSteps.length } }}</p>
      <div class="button-row">
        <button type="button" class="lg-button form-next-button" (click)="reloadTransfer()">
          {{ 'transfer.completion.another_transfer' | translateLang }}
        </button>
        <button type="button" class="lg-button form-back-button" (click)="goToDashboard()">
          {{ 'transfer.completion.back_to_dashboard' | translateLang }}
        </button>
      </div>
    </div>
  }

  } <!-- end @else pageLoading -->

</div>
